import {
  Document,
  DocumentDetails,
  DocumentDownload,
  DocumentDownloadLink,
  DocumentsList,
  DownloadLoadingSpinner,
} from "pages/Application/Recommendation/Recommendation.styles"
import { Loader, LoaderTheme } from "components/atoms/Loader"
import React from "react"

interface RecommendationDocumentsSectionProps {
  downloading: boolean
  preview: boolean
  href: string
  onClick: () => Promise<void> | void
}

export const RecommendationDocumentsSection = ({
  downloading,
  preview,
  href,
  onClick,
}: RecommendationDocumentsSectionProps): JSX.Element => {
  return (
    <DocumentsList aria-label="Documents">
      <Document>
        <DocumentDetails>
          <span>Mortgage Illustration</span>
          <p>
            This document outlines the full details and risks of the mortgage product being
            recommended, please ensure you take the time to read through.
          </p>
        </DocumentDetails>
        {downloading ? (
          <DownloadLoadingSpinner>
            <Loader size={32} theme={LoaderTheme.Outline} />
          </DownloadLoadingSpinner>
        ) : (
          <>
            {preview ? (
              <DocumentDownloadLink href={href}>
                <span>Download</span>
              </DocumentDownloadLink>
            ) : (
              <DocumentDownload onClick={onClick}>
                <span>Download</span>
              </DocumentDownload>
            )}
          </>
        )}
      </Document>
    </DocumentsList>
  )
}
